import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { Editor } from 'slate';

var BlockElementUtils = function BlockElementUtils(editor) {
  var _this = this;

  _classCallCheck(this, BlockElementUtils);

  this.getActiveHeader = function (types) {
    var selection = _this.editor.selection;
    if (!selection) return false;
    var match = Editor.match(_this.editor, selection, types);
    if (!match) return [{
      type: 'paragraph'
    }];
    return match;
  };

  this.isBlockActive = function (type) {
    var selection = _this.editor.selection;
    if (!selection) return false;

    var _Editor$nodes = Editor.nodes(_this.editor, {
      match: {
        type: type
      }
    }),
        _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
        match = _Editor$nodes2[0];

    return !!match;
  };

  this.editor = editor;
};

export default BlockElementUtils;